import React, { useContext } from "react";

const Title = () => {
  return (
    <>
      <div className=" text-center main-heading my-4 py-3">
        Angry ? Hungry ? Dazzy ? Fizzy ?
      </div>

      <div className="text-center main-heading">Just search Here!</div>
    </>
  );
};

export default Title;
